import { LoyaltyBasketItem } from '@libs/common-node';
import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

type TreatPointsBody = {
    sku: string;
    price: number;
    quantity: number;
    userLoyaltyId?: number;
};

export async function getTreatPoints<T>({
    sku,
    price,
    quantity,
    userLoyaltyId,
}: TreatPointsBody): Promise<Nullable<T>> {
    const url = CWEA_ENDPOINTS.treatPoints.get();

    return await cweaClient.post<T, LoyaltyBasketItem[]>(url, {
        headers: {
            ...(userLoyaltyId ? { 'x-petm-customer-loyalty-number': userLoyaltyId.toString() } : {}),
        },
        body: [
            {
                productSku: sku,
                productQuantity: quantity,
                qualifyingPrice: price,
            },
        ],
        useOldFetch: true,
    });
}
